module.exports = __webpack_public_path__ + "img/BulgarianCard2.32c7faab.jpg";